/**
 * Klaviyo list subscribe (legacy ajax endpoint), then native Shopify contact submit.
 * @see https://manage.kmail-lists.com/ajax/subscriptions/subscribe
 */
if (!customElements.get('ambassador-contact-form-klaviyo')) {
  class AmbassadorContactFormKlaviyo extends HTMLElement {
    static KMAIL_SUBSCRIBE_URL = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

    static async postMail(profiles) {
      const res = await fetch(this.KMAIL_SUBSCRIBE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: profiles,
      });
      const text = await res.text();
      try {
        return text ? JSON.parse(text) : {};
      } catch {
        return { _parseError: true, raw: text };
      }
    }

    constructor() {
      super();
      this._onSubmit = this._onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('#AmbassadorContactForm');
      this.listId = (this.dataset.listId || '').trim();
      if (!this.form || !this.listId) return;

      this.form.addEventListener('submit', this._onSubmit, { passive: false });
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }

    static buildKlaviyoParams(form) {
      const params = new URLSearchParams();
      const fd = new FormData(form);
      const nonEmailFieldNames = [];
      let email = '';

      for (const [key, value] of fd.entries()) {
        if (typeof value !== 'string') continue;
        const m = /^contact\[(.+)\]$/.exec(key);
        if (!m) continue;
        if (m[1] === 'email') {
          email = value.trim();
          break;
        }
      }

      if (email) {
        params.append('email', email);
      }

      for (const [key, value] of fd.entries()) {
        if (typeof value !== 'string') continue;
        const m = /^contact\[(.+)\]$/.exec(key);
        if (!m) continue;
        const name = m[1];
        if (name === 'email') continue;
        params.append(name, value);
        nonEmailFieldNames.push(name);
      }

      params.append('$fields', nonEmailFieldNames.join(','));
      return params;
    }

    async _onSubmit(event) {
      if (!this.form.checkValidity()) return;

      event.preventDefault();

      const profiles = AmbassadorContactFormKlaviyo.buildKlaviyoParams(this.form);
      const email = profiles.get('email');
      if (!email) {
        HTMLFormElement.prototype.submit.call(this.form);
        return;
      }

      profiles.append('g', this.listId);

      const submitBtn = this.form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const json = await this.constructor.postMail(profiles);
        if (json.errors && json.errors.length !== 0) {
          console.warn('[Ambassador Klaviyo]', json);
        }
      } catch (err) {
        console.warn('[Ambassador Klaviyo] Request failed', err);
      } finally {
        HTMLFormElement.prototype.submit.call(this.form);
      }
    }
  }

  customElements.define('ambassador-contact-form-klaviyo', AmbassadorContactFormKlaviyo);
}
